module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-Bold.33a327aa.ttf";